module.exports = __webpack_public_path__ + "static/media/container-volume.1b73ce02.svg";